"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _react2 = require("@iconify/react");
var _phone = _interopRequireDefault(require("@iconify-icons/flat-color-icons/phone"));
var _print = _interopRequireDefault(require("@iconify-icons/flat-color-icons/print"));
var _feedback = _interopRequireDefault(require("@iconify-icons/flat-color-icons/feedback"));
var _appContext = _interopRequireDefault(require("../../context/appContext"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  imageWrapper: {
    display: "flex"
  },
  addition: {
    margin: theme.spacing(0, 0, 0.5)
  },
  iconWrapper: {
    display: "flex",
    "& > *": {
      display: "flex"
    },
    "& a:hover": {
      textDecoration: "underline"
    }
  },
  icon: {
    height: 24,
    margin: theme.spacing(0, 1, 1, 0),
    width: 24
  }
}));
const WebsiteProfile = props => {
  const {
    noLogo
  } = props;
  const {
    REACT_APP_LOGO,
    PUBLIC_URL,
    REACT_APP_LOGOMAXWIDTH
  } = process.env;
  const [appData] = (0, _react.useContext)(_appContext.default);
  const css = useStyles();
  if (!(0, _lodash.isEmpty)(appData)) {
    const {
      name,
      addition,
      street,
      zip,
      city,
      phone,
      fax,
      mail,
      vat,
      companyRegister
    } = appData;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, noLogo !== true ? /*#__PURE__*/_react.default.createElement(_core.Box, {
      mb: 3,
      className: css.imageWrapper
    }, /*#__PURE__*/_react.default.createElement("img", {
      style: {
        display: "block",
        maxWidth: REACT_APP_LOGOMAXWIDTH,
        width: "100%"
      },
      src: PUBLIC_URL + "/img/" + REACT_APP_LOGO,
      alt: ""
    })) : "", /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "subtitle1",
      dangerouslySetInnerHTML: {
        __html: name
      }
    }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: css.addition,
      variant: "body2",
      dangerouslySetInnerHTML: {
        __html: addition
      }
    }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      dangerouslySetInnerHTML: {
        __html: street
      }
    }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      dangerouslySetInnerHTML: {
        __html: zip + " " + city
      }
    })), /*#__PURE__*/_react.default.createElement(_core.Box, {
      my: 1
    }, vat ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
      dangerouslySetInnerHTML: {
        __html: "UID-Nummer: " + vat
      }
    }) : "", companyRegister ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
      dangerouslySetInnerHTML: {
        __html: "Firmenbuchnummer: " + companyRegister
      }
    }) : ""), /*#__PURE__*/_react.default.createElement(_core.Box, {
      mt: 1
    }, mail ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: css.iconWrapper
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "mailto:" + mail
    }, /*#__PURE__*/_react.default.createElement(_react2.InlineIcon, {
      className: css.icon,
      icon: _feedback.default
    }), mail)) : "", phone ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: css.iconWrapper
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "tel:" + phone
    }, /*#__PURE__*/_react.default.createElement(_react2.InlineIcon, {
      className: css.icon,
      icon: _phone.default
    }), phone)) : "", fax ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: css.iconWrapper
    }, /*#__PURE__*/_react.default.createElement(_react2.InlineIcon, {
      className: css.icon,
      icon: _print.default
    }), fax) : "")));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
var _default = exports.default = WebsiteProfile;